var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { FilterData } from 'path-shared/models/filter-data';
var PendentsFilter = /** @class */ (function (_super) {
    __extends(PendentsFilter, _super);
    function PendentsFilter(sortField, sortDir) {
        return _super.call(this, sortField, sortDir) || this;
    }
    return PendentsFilter;
}(FilterData));
export { PendentsFilter };
